import _reject from 'lodash/reject';
import _map from 'lodash/map';
import _isNull from 'lodash/isNull';
import _isEmpty from 'lodash/isEmpty';

export const transformBlocks = blocks =>
  _map(blocks, ({ name, intent_reference, conditions }) => ({
    name,
    intent_reference,
    conditions: _map(conditions, ({ entity, operator, features }) => ({
      entity,
      operator,
      features: _map(features, ({ feature, operator, equals_values }) => ({
        feature,
        operator,
        equals_values: _map(
          _reject(equals_values, _isNull),
          value => (value.text ? value.text : value),
        ),
      })),
    })),
  }));

export const flattenFeatures = entities => {
  const featuresFlatten = [];

  for (const entity of entities) {
    const keyValue = _isEmpty(entity.value) ? '' : '.value';
    featuresFlatten.push({
      key: entity.name + keyValue,
      value: entity.value || '',
      parent: entity.parent,
    });

    for (const featureKey of Object.keys(entity.selection_features)) {
      featuresFlatten.push({
        key: `${entity.name}.${featureKey}`,
        value: entity.selection_features[featureKey],
        parent: entity.parent,
      });
    }
  }

  return featuresFlatten;
};

export const getFeaturesMap = (features, featureTypes) =>
  features.reduce((acc, item) => {
    if (item.public) {
      return {
        ...acc,
        [item.id]: {
          ...item,
          available_values: featureTypes.find(
            featureType => featureType.name === item.feature_type,
          ).available_values,
        },
      };
    }
    return acc;
  }, {});
